import { forwardRef } from 'react'

import Checkbox from './_components/checkbox'
import CheckboxGroup from './_components/checkbox-group'
import Date from './_components/date'
import FileInput from './_components/file'
import Input from './_components/input'
import InputPassword from './_components/input-password'
import NumberInput from './_components/number'
import Otp from './_components/otp'
import Phone from './_components/phone'
import RadioGroup from './_components/radio-group'
import Select from './_components/select'
import SelectAutoComplete from './_components/select-auto-complete'
import StorageQuotaInput from './_components/storage-quota'
import Textarea from './_components/textarea'
import type { ControlType, HeroControlProps } from './types'

const COMPONENT_MAP = new Map<ControlType, React.FC<any>>([
  ['text', Input],
  ['email', Input],
  ['password', InputPassword],
  ['select', Select],
  ['checkbox', Checkbox],
  ['select-auto-complete', SelectAutoComplete],
  ['radio-group', RadioGroup],
  ['checkbox-group', CheckboxGroup],
  ['textarea', Textarea],
  ['file', FileInput],
  ['date', Date],
  ['number', NumberInput],
  ['otp', Otp],
  ['phone', Phone],
])

const HeroControl = forwardRef<any, HeroControlProps>((props, ref) => {
  const { control, ...rest } = props
  const Component = COMPONENT_MAP.get(control)

  return Component ? <Component ref={ref} {...rest} /> : null
})

export default HeroControl

// Export individual components
export {
  Checkbox,
  CheckboxGroup,
  Date,
  FileInput,
  Input,
  InputPassword,
  NumberInput,
  Otp,
  Phone,
  RadioGroup,
  Select,
  SelectAutoComplete,
  StorageQuotaInput,
  Textarea,
}

// Export types
export type { ControlType, HeroControlProps }
